<script lang="ts">
	import StaticEventTile from './StaticEventTile.svelte';
	import type { PublicListingEvent } from '$lib/vivenu/types';
	import { buildEventUrl, buildVivenuLoginUrl } from '$lib/links';
	import { locale } from 'svelte-i18n';
	import { localizeUrl } from '$lib/i18n';
	import { page } from '$app/stores';

	export let event: PublicListingEvent;
	export let hover = false;
	export let hideMeta = false;
	export let removeLink = false;
	export let protectedEvent =
		event && event.accountSettings && event.accountSettings.enforceAccounts
			? !$page.data.session
				? true
				: false
			: false;

	$: url = protectedEvent
		? `/${$locale}/auth/login?redirect_uri=` +
		  buildVivenuLoginUrl(buildEventUrl(event, $page.data.vivenuExchangeToken), 'temp')
		: buildEventUrl(event, $page.data.vivenuExchangeToken);
</script>

{#if removeLink}
	<StaticEventTile {hideMeta} {event} {hover} deemphasise={protectedEvent} />
{:else}
	<a href={localizeUrl(url, $locale)} class:protectedEvent>
		<StaticEventTile {event} {hover} deemphasise={protectedEvent} />
	</a>
{/if}

<style>
	a {
		position: relative;

		text-decoration: none !important;
		transition: all 0.2s ease-in-out;
		box-shadow: 0 0 12px rgba(0, 0, 0, 16%);

		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* height: 100%; */

		color: #222;
		text-decoration: none !important;
		word-wrap: break-word;

		border: 1px solid #e5e5e5;
		border-radius: 6px;
	}
	.protectedEvent:before {
		position: absolute;
		top: 1.0275rem;
		left: 1rem;
		display: flex;
		padding: 0.16rem 15px 0.16rem 33px;
		justify-content: center;
		align-items: center;
		text-align: center;
		color: white;
		font-size: small;
		font-family: 'Schalke04Text-Bold';
		content: 'LOGIN';
		white-space: pre;
		background: #4bafe8;
		background-image: url("data:image/svg+xml,%3Csvg id='Layer_1' style='enable-background:new 0 0 30 30;' version='1.1' viewBox='0 0 30 30' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%23fff' d='M24,27H6c-1.105,0-2-0.895-2-2V13c0-1.105,0.895-2,2-2h18c1.105,0,2,0.895,2,2v12C26,26.105,25.105,27,24,27z'/%3E%3Cpath d='M9,12 V9c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6v3' style='fill:none;stroke:%23fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;'/%3E%3C/svg%3E");
		background-size: 15px;
		background-repeat: no-repeat;
		background-position: 10px 50%;
		border-radius: 0.5rem;
		z-index: 2;
	}
</style>
